module.exports = __webpack_public_path__ + "img/9CC338_4E671A_799F27_8CAC2C-256px.6de02065.png";